import { ElMessage } from 'element-plus'

export const ALIYUN_TOKEN_EXPIRED_CODE = 'ALIYUN_TOKEN_EXPIRED'
export const ALIYUN_REBIND_EVENT = 'aliyun-storage-rebind-request'

function clearStorageCacheAsync() {
  void import('@/utils/storageCheck').then(({ clearStorageCache }) => clearStorageCache())
}

export function isAliyunTokenExpiredError(error) {
  const code = error?.code
    || error?.response?.data?.code
    || error?.errorCode
  const message = error?.message
    || error?.response?.data?.message
    || ''
  return code === ALIYUN_TOKEN_EXPIRED_CODE
    || message.includes('expired refresh_token')
    || message.includes('授权已过期')
    || message.includes('请重新扫码绑定')
}

/**
 * 弹出阿里云盘扫码重绑流程（全局 CustomEvent，由 UserProfile 监听）
 */
export function requestAliyunRebind(detail = {}) {
  clearStorageCacheAsync()
  const message = detail.message || '阿里云盘授权已过期，请重新扫码绑定'
  if (detail.silent !== true) {
    ElMessage.warning(message)
  }
  window.dispatchEvent(new CustomEvent(ALIYUN_REBIND_EVENT, {
    detail: { ...detail, message }
  }))
}

/**
 * 检测到 token 过期时清缓存并触发重绑弹窗
 * @returns {boolean} 是否已识别为过期并处理
 */
export function handleAliyunTokenExpired(error, options = {}) {
  if (!isAliyunTokenExpiredError(error)) {
    return false
  }
  requestAliyunRebind({
    reason: options.reason || 'token_expired',
    message: error?.message || error?.response?.data?.message,
    silent: options.silent === true
  })
  return true
}
